export default __webpack_public_path__ + "static/media/carta5.b4f954b8.png";